import { NavigateFunction } from "react-router-dom";

export const handleRoleBasedNavigation = (
  userRole: string | null | undefined,
  allowedRoles: string[],
  navigate: NavigateFunction,
) => {
  if (userRole === "new-user") {
    navigate("/first-login", { replace: true });
    return;
  }

  if (!userRole || userRole === "no-access" || !allowedRoles.includes(userRole)) {
    navigate("/unauthorized", { replace: true });
    return;
  }
  return false;
};
